import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

import type { Comment } from '../../../../types';

type Params = {
	comments: readonly Comment[];
	loadMore: () => void;
};

export function useCommentsList({ comments, loadMore }: Params) {
	const {
		data: {
			petition: { id: petitionId },
		},
	} = useStarterDashboardV2PageData();
	const track = useTracking();

	return {
		actions: {
			loadMore: useCallback(() => {
				loadMore();
				void track('comment_feed_scroll', {
					comment_feed_type: 'recent',
					commentable_id: petitionId,
					commentable_type: 'Event',
					comment_count: comments.length,
				});
			}, [comments.length, loadMore, petitionId, track]),
		},
	};
}
